'use strict';
import topCatList from './components/topic-cat-list';
import winsList from './components/index-wins-list';

module.exports = function () {
    console.log('MIC Index');
    topCatList();
    winsList();
};
